export var Trigger;
(function (Trigger) {
    Trigger["CustomerViewsRecommendation"] = "CustomerViewsRecommendation";
    Trigger["CustomerGoesToCheckoutFromRecommendation"] = "CustomerGoesToCheckoutFromRecommendation";
    Trigger["CustomerGoesToViewProductPage"] = "CustomerGoesToViewProductPage";
})(Trigger || (Trigger = {}));
